import { useDispatch, useSelector } from 'react-redux'
import { CoachMark } from '../../../coachMark'
import { coachMarkRoutes } from '../../../coachMark/constants'
import { COMPONENTS } from '../../../routers/constants'
import { COMPANY_TYPES } from '../../../utils/common'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import { PreferenceSetting } from '../../common/preferenceSetting'
import SettingPanel from './SettingPanel'
import { getDetailPanel, getKeyPanels, saveTemplate } from './helper'
import {
  applySetting,
  keyLoading,
  selectCurrentTemplate,
  selectDefaultTemplate,
  selectIsFiinGateTemplate,
  selectIsNotHasChange,
  selectLoading,
  selectPanelById,
  selectPanelId,
  selectTemplateId,
  selectTemplateName,
  selectTemplateSearch,
  selectTemplates,
  selectTotalRecord,
  setIsNotHasChange,
} from './store/slice'
import {
  deleteTemplatesThunk,
  getDefaultTemplateThunk,
  getTemplateDetailThunk,
  getTemplatesSearchThunk,
  getTemplatesThunk,
  setDefaultTemplateThunk,
  updateTemplateThunk,
} from './store/thunk'

const PreferenceSettingFinancialAnalysis = ({ setIsShowPreferenceSetting }) => {
  const dispatch = useDispatch()

  const companyType = useSelector(selectCompanyInfo).companyType
  const loadingTemplate = useSelector(selectLoading(keyLoading.TEMPLATE))
  const loadingDefaultTemplate = useSelector(
    selectLoading(keyLoading.DEFAULT_TEMPLATE),
  )
  const templates = useSelector(selectTemplates)
  const totalRecord = useSelector(selectTotalRecord)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const templateName = useSelector(selectTemplateName)
  const isFiinGateTemplate = useSelector(selectIsFiinGateTemplate)
  const templateId = useSelector(selectTemplateId)
  const defaultTemplate = useSelector(selectDefaultTemplate)
  const loadingSearch = useSelector(selectLoading(keyLoading.TEMPLATE_SEARCH))
  const templateSearch = useSelector(selectTemplateSearch)
  const isNotHasChange = useSelector(selectIsNotHasChange)
  const currentTemplate = useSelector(selectCurrentTemplate)

  const callApiTemplates = (param) => {
    dispatch(getTemplatesThunk(param))
  }

  const callApiDefaultTemplate = (param) => {
    dispatch(getDefaultTemplateThunk(param))
  }

  const handleBack = () => {
    setIsShowPreferenceSetting(false)
  }

  const setDefaultTemplate = (data) => {
    dispatch(setDefaultTemplateThunk(data))
  }

  const deleteTemplate = (data) => {
    dispatch(
      deleteTemplatesThunk({
        ...data,
        param: {
          financialAnalysisTemplateIds: data.param.ids,
          templateType: data.param.templateType,
          deleteType: data.param.deleteType,
        },
      }),
    )
  }

  const updateTemplate = (data) => {
    dispatch(updateTemplateThunk(data))
  }

  const getPanels = (companyType) => {
    const keysPanel = getKeyPanels(companyType)
    return keysPanel.map((key) => {
      const detailPanel = getDetailPanel(key)
      return {
        key,
        label: detailPanel.label,
        type: detailPanel.type,
      }
    })
  }

  const apply = (data) => {
    dispatch(applySetting(data))
    if (isNotHasChange) {
      dispatch(setIsNotHasChange(data.isNotHasChange))
    }
    handleBack()
  }

  const callApiSearch = (value) => {
    dispatch(getTemplatesSearchThunk(value))
  }

  const getCurrentTemplate = (id) => {
    dispatch(
      getTemplateDetailThunk({
        params: { FinancialAnalysisTemplateId: id },
        companyType,
      }),
    )
  }

  return (
    <CoachMark
      id={
        coachMarkRoutes[
          '/companyAnalysis/financial/financialAnalysis?preferenceSetting=true'
        ]
      }
    >
      <PreferenceSetting
        handleBack={handleBack}
        template={{
          callApi: callApiTemplates,
          data: templates,
          loading: loadingTemplate || loadingDefaultTemplate,
          total: totalRecord,
          idKey: 'financialAnalysisTemplateId',
          nameKey: 'financialAnalysisTemplateName',
          dataKey: 'financialAnalysisTemplateData',
          setDefaultTemplate,
          deleteTemplate,
          updateTemplate,
          callApiDefaultTemplate,
          defaultTemplate,
          callApiSearch,
          loadingSearch,
          dataTemplateSearch: [
            {
              templateType: COMPANY_TYPES.CORPORATE,
              title: 'preferenceSetting.CORPORATE',
              data: templateSearch[COMPANY_TYPES.CORPORATE],
            },
            {
              templateType: COMPANY_TYPES.BANK,
              title: 'preferenceSetting.BANK',
              data: templateSearch[COMPANY_TYPES.BANK],
            },
            {
              templateType: COMPANY_TYPES.NON_BANK,
              title: 'preferenceSetting.NON_BANK',
              data: templateSearch[COMPANY_TYPES.NON_BANK],
            },
            {
              templateType: COMPANY_TYPES.SECURITIES,
              title: 'preferenceSetting.SERCURITY',
              data: templateSearch[COMPANY_TYPES.SECURITIES],
            },
            {
              templateType: COMPANY_TYPES.LIFE_INSURANCE,
              title: 'preferenceSetting.LIFE_INSURANCE',
              data: templateSearch[COMPANY_TYPES.LIFE_INSURANCE],
            },
            {
              templateType: COMPANY_TYPES.NON_LIFE_INSURANCE,
              title: 'preferenceSetting.NON_LIFE_INSURANCE',
              data: templateSearch[COMPANY_TYPES.NON_LIFE_INSURANCE],
            },
          ],
          typeCompanyDisable: [COMPANY_TYPES.FUNDS, COMPANY_TYPES.INSURANCE],
        }}
        detailTemplate={{
          getPanels,
          panelsSelected: panelId.map((id) => {
            const panel = panelById[id]

            return {
              ...panel,
              setting: panel?.setting
                ? { ...panel.setting, year: null }
                : undefined,
            }
          }),
          templateName,
          templateId,
          isFiinGateTemplate,
          formatDefaultPanel: (panel) => getDetailPanel(panel.key),
          renderSettingPanel: ({ panel, setValue, defaultPanel }) => (
            <SettingPanel
              panel={panel}
              setValue={setValue}
              defaultPanel={defaultPanel}
            />
          ),
          saveTemplate: async (data) => {
            const result = await saveTemplate(data, companyType)
            if (result && data.templateId && data.companyType === companyType) {
              dispatch(applySetting(data))
              dispatch(setIsNotHasChange(true))
            }
            return result
          },
          apply,
          path: COMPONENTS.companyAnalysis.components.financial.components
            .financialAnalysis.route,
          getCurrentTemplate,
          currentTemplate,
        }}
      />
    </CoachMark>
  )
}

export default PreferenceSettingFinancialAnalysis
